export function isObject<T extends object = Record<string, unknown>>(val: unknown): val is T {
  return typeof val === "object" && val !== null && !Array.isArray(val);
}
